import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface ProgressState {
    total: number;
    success: number;
    progress: number;
    isProcessing: boolean;
}

@Injectable({
    providedIn: 'root'
})
export class WhatsappProgressService {

    private progressSubject = new BehaviorSubject<ProgressState>({
        total: 0,
        success: 0,
        progress: 0,
        isProcessing: false
    });

    progress$ = this.progressSubject.asObservable();

    start(total: number) {
        this.progressSubject.next({
            total,
            success: 0,
            progress: 0,
            isProcessing: true
        });
    }

    update(success: number, total: number) {
        const progress = Math.round((success / total) * 100);

        this.progressSubject.next({
            total,
            success,
            progress,
            isProcessing: true
        });
    }

    complete() {
        const current = this.progressSubject.value;

        this.progressSubject.next({
            ...current,
            progress: 100,
            isProcessing: false
        });
    }

    reset() {
        this.progressSubject.next({
            total: 0,
            success: 0,
            progress: 0,
            isProcessing: false
        });
    }
}